// extracted by mini-css-extract-plugin
module.exports = {"main-details":"DeliveryDetails_main-details__mN53T","inline-details":"DeliveryDetails_inline-details__kFuku"};